import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'ecp-hero-toolbar',
  templateUrl: './hero-toolbar.component.html',
  styleUrls: ['./hero-toolbar.component.scss'],
  standalone: false,
})
export class HeroToolbarComponent {
  @HostBinding('class.hero__toolbar') hero__toolbar = true;
}
